/* sg-cart-notification-qty.js
   Wires the quantity stepper inside <cart-notification> to /cart/change.js.
   Uses event delegation so it survives AJAX re-renders of the inner content
   (cart-notification.js swaps innerHTML, which strips inline <script> tags). */

(function () {
  function findCart(cart) {
    return cart && cart.item_count != null ? cart : null;
  }

  function updateCount(itemCount) {
    document.querySelectorAll('.sg-cart-notification__count').forEach(function (el) {
      el.textContent = '(' + itemCount + ')';
    });
  }

  var pending = new Map(); // key -> timer id, debounce per line item

  function syncLine(input) {
    var key = input.dataset.sgCartKey;
    var requested = parseInt(input.value, 10);
    if (!key || isNaN(requested) || requested < 0) return;

    // Always fetch fresh cart state after the change attempt (succeed or fail)
    // so we know the *actual* server quantity. Shopify returns 422 when the
    // requested qty exceeds stock — without this follow-up read, the input
    // would visually drift from server state.
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: requested }),
    })
      .then(function () { return fetch('/cart.js', { headers: { Accept: 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var c = findCart(cart);
        if (!c) return;
        updateCount(c.item_count);

        var matched = (c.items || []).find(function (it) { return it.key === key; });
        var serverQty = matched ? matched.quantity : 0;

        if (parseInt(input.value, 10) !== serverQty) {
          input.value = serverQty;
          var stepper = input.closest('.sg-cart-notification-item__quantity');
          if (stepper && requested > serverQty) {
            stepper.classList.add('sg-cart-notification-item__quantity--clamped');
            setTimeout(function () {
              stepper.classList.remove('sg-cart-notification-item__quantity--clamped');
            }, 1200);
          }
        }

        if (serverQty === 0) {
          var itemEl = input.closest('.sg-cart-notification-item');
          if (itemEl) itemEl.remove();
        }
      })
      .catch(function () {});
  }

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.matches('.sg-cart-notification-item__quantity input.quantity__input')) return;
    var key = input.dataset.sgCartKey;
    if (!key) return;
    // Debounce: when a user clicks +/+/+/+ quickly, we want one POST with the
    // final value, not four parallel POSTs that race each other.
    var existing = pending.get(key);
    if (existing) clearTimeout(existing);
    pending.set(key, setTimeout(function () {
      pending.delete(key);
      syncLine(input);
    }, 250));
  });
})();
